module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridIntermediates/sections/11_esGooberStory/level3_egstory.md
// module id = 1543
// module chunks = 2